import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AppConfigModule, LOGIN_DIRECTIVES } from '@alfresco/adf-core';

import { WkLoginComponent } from './wk-login.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ...LOGIN_DIRECTIVES,
    AppConfigModule,
    TranslateModule,
  ],
  declarations: [WkLoginComponent],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'auto' },
    },
  ],
})
export class WkLoginModule {}
